import { render } from "./SimpleDateTimePicker.vue?vue&type=template&id=52456420"
import script from "./SimpleDateTimePicker.vue?vue&type=script&lang=js"
export * from "./SimpleDateTimePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__